import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { CTASection } from "@/components/home/CTASection";
import { PackageRecommender } from "@/components/PackageRecommender";
import { VerticalVideosSection } from "@/components/home/VerticalVideosSection";
import { FeaturedVideosSection } from "@/components/home/FeaturedVideosSection";

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <FeaturedVideosSection />
      <VerticalVideosSection />
      <PackageRecommender />
      <TestimonialsSection />
      <CTASection />
    </Layout>
  );
};

export default Index;
